<template>
  <div>
    <v-btn-toggle
      v-if="isSearchLibraryUnlocked"
      mandatory
      v-model="selectedTab"
      dense
    >
      <v-btn x-small value="saved_searches">Saved Searches</v-btn>
      <v-btn x-small value="search_library">Search Library</v-btn>
    </v-btn-toggle>
    <v-container class="my-0 py-0">
      <v-row>
        <v-col class="my-0 py-0">
          <SearchesList
            v-if="selectedTab === 'saved_searches'"
            :selected="selected"
            @select="handleSelect"
          ></SearchesList>
          <SearchLibraryList
            v-if="selectedTab === 'search_library'"
            :selected="selected"
            @select="handleSelect"
          ></SearchLibraryList>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { hasEssentialsAccess } from "@/services/user/user.service";

export default {
  name: "NotificationsSearches",
  components: {
    SearchesList: () => import("@/components/search/SearchesList"),
    SearchLibraryList: () =>
      import("@/components/search/library/SearchLibraryList"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
  },
  data: () => ({
    modal: false,
    selectedTab: "saved_searches",
  }),
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    isSearchLibraryUnlocked() {
      return this.featureUnlocked("search-library") && !hasEssentialsAccess();
    },
  },
  mounted() {},
  methods: {
    closeModal() {
      this.modal = false;
    },
    handleClickCancel() {
      this.closeModal();
    },
    handleSelect(notification) {
      this.update(notification);
    },
    update(notification) {
      if (this.selectedTab === "search_library")
        notification.searchLibrary = true;
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
};
</script>

<style scoped></style>
